import { useState, useEffect, useRef } from 'react';

import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import lcMsgTips from '@lcsc-ui/utils/lcMsgTips';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { Modal, Button, message } from 'antd';

import DialogLeft from './components/dialogLeft';
import DialogRight from './components/dialogRight';

import API from '@/apis/index';

export default function GoBuyDialog({ type, row, productData, isModalOpen, setIsModalOpen }) {
  const { userInfo, updateUserInfo } = useUserStore();
  const fromZone = useUserStore((state) => state.fromZone);
  const [isOpen, setIsOpen] = useState(isModalOpen);
  const [childValue, setChildValue] = useState(
    row?.productMinEncapsulationNumber ? row?.productMinEncapsulationNumber : 1
  );
  const [loading, setLoading] = useState(false);
  const addBtnRef = useRef(null);

  useEffect(() => {
    setIsOpen(isModalOpen);
  }, [isModalOpen]);

  const handleOk = () => {
    let number = childValue;
    if (number < row?.productMinEncapsulationNumber) {
      number = row?.productMinEncapsulationNumber;
    } else if (number % row?.ratio !== 0) {
      number = Number(row?.ratio) * Math.ceil(number / row?.ratio);
    }

    if (number / row?.ratio < 1 || number % row?.ratio !== 0) {
      return;
    }
    const str = '0~' + productData?.productId + '~' + number / row?.ratio;
    // 正常普通加购
    const url = API.cartAddNormal;
    const { lcsc_vid = '', spm = '' } = Utils.getButtonParams(addBtnRef.current);
    const data = { cartKeyStr: str, entryType: 'product_details', trackZone: fromZone, lcscVid: lcsc_vid, spm };
    setLoading(true);
    sendAxios({
      method: 'post',
      data,
      url,
      baseURL: Domains.lcscCartApiUrl,
    })
      .then((res) => {
        if (res.needLogin) {
          gotoLogin();
          return;
        }
        if (res?.result?.shifting) {
          lcMsgTips.showConfirmModal({
            title: res?.result?.shifting,
          });
        } else if (res?.msg && res?.msg.indexOf('needLogin') >= 0) {
          window.location.href = '/login.html';
        } else if (res?.code === 200) {
          message.success('加入购物车成功！');
          updateUserInfo({ ...userInfo, cartNum: res?.result?.cart_contains_count });
        }
      })
      .finally(() => {
        setLoading(false);
      });
    // 加购埋点
    buriedPoint({
      cp: 'product_detail',
      ty: 'click',
      op: 'ADD_CART',
      data: {
        type: 'ADD_CART',
        suggest: productData?.recommendType === 'connector' ? 'connector' : `${type === 'mro' ? 'MRO' : ''}recommend`,
      },
    });
  };
  // 跳登录和注册
  const gotoLogin = (type) => {
    const url = Utils.getCasTypeUrl(type);
    window.open(url, '_self');
  };
  const handleCancel = () => {
    setIsOpen(false);
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        data-spm="xjx"
        centered
        width="800px"
        title="添加购物车"
        cancelText=""
        open={isOpen}
        onCancel={handleCancel}
        footer={[
          <Button
            ref={addBtnRef}
            data-spm="iad"
            key="submit"
            type="primary"
            danger
            onClick={handleOk}
            loading={loading}
          >
            {row?.validStockNumber > 0 ? '加入购物车' : '我要订货'}
          </Button>,
        ]}
      >
        <div className="flex text-[14px]">
          <DialogLeft row={row} />
          <DialogRight row={row} setParentValue={(e) => setChildValue(e)} />
        </div>
      </Modal>
    </>
  );
}
